import React from 'react';

import classes from './WidgetButtonsWrapper.module.scss';

interface Props {
    children: React.ReactNode;
    className?: string;
}

export const WidgetButtonsWrapper = ({ children, className }: Props) => {
    return <div className={classes.widgetButtonsWrapper}>{children}</div>;
};
